import { Inspecao } from "../../../services/relatorio";
import { Item, Relatorio } from './../../../services/relatorio/index';

export type Modulos = "CABINA INTERNA" | "PAVIMENTO" | "MAQUINÁRIO & COMANDO"
  | "CABINA EM CIMA" | "CAIXA DE CORRIDA" | "POÇO";

export const ModuloMap = {
  "1": "CABINA INTERNA",
  "2": "PAVIMENTO",
  "3": "MAQUINÁRIO & COMANDO",
  "4": "CABINA EM CIMA",
  "5": "CAIXA DE CORRIDA",
  "6": "POÇO"
} as { [key: string]: Modulos }

export const DecodeModulo = {
  "CABINA INTERNA": "1",
  "PAVIMENTO": "2",
  "MAQUINÁRIO & COMANDO": "3",
  "CABINA EM CIMA": "4",
  "CAIXA DE CORRIDA": "5",
  "POÇO": "6"
} as { [key: string]: string }

export const ModuloList = Object.keys(ModuloMap).map(key => ModuloMap[key]);
export interface PerguntasProps { 
  referencias: string[] 
  modulo: string
  modulo_id: string
  query: RelatorioQuery
  lock: boolean

  reload: Function
  setLock: React.Dispatch<React.SetStateAction<boolean>>
}
export interface PickerEquipamento {
  query: RelatorioQuery
  modulo: string,
  reload: Function
}
export interface RelatorioQuery {
  relatorio: Relatorio,
  inspecao: Inspecao,
  perguntas: Item[]
  equipamentos: {
    equipamento_id: string,
    inspecao_id: string
  }[]
  totalItems: number
  totalFeitos: number
  porcentagem: number,
  porcentagemIndividual: { [key: string]: number},

}

